import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Button, Confirm } from 'semantic-ui-react'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import { reduxForm, getFormValues, Field } from 'redux-form'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { createProvince, updateProvince } from 'ducks/dataManagement'

import r from 'reactotron-react-js'

const ProvinceModal = (props) => {
  const { valueForm, onClose } = props

  const [showConfirmDelete, setShowConfirmDelete] = useState(false)
  const [showConfirmSave, setShowConfirmSave] = useState(false)

  return (
    <Dialog open={true} maxWidth='md' style={{ zIndex: 10 }}>
      <DialogTitle>Province</DialogTitle>
      <DialogContent>
        <form>
          <Field name='nameTh' require label='Name TH' type={type.text} component={FieldInput} />
          <Field name='nameEn' label='Name EN' type={type.text} component={FieldInput} />
          <Field name='code' require label='Code' placeholder='รหัสจังหวัด (2 ตัวแรกของรหัสไปรษณีย์)' type={type.text} component={FieldInput} />
        </form>
      </DialogContent>
      <DialogActions>
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', padding: '0px 15px' }} >
          <div>
            {
              // valueForm.id ? 
              //   <Button
              //     type='button'
              //     content='Delete'
              //     color='red'
              //     icon='trash alternate'
              //     labelPosition='right'
              //     style={{ marginRight: '5px' }}
              //     onClick={() => setShowConfirmDelete(true) }
              //   /> : null
            }
          </div>
          <div>
            {
              valueForm.id ? 
                <Button
                  type='button'
                  content='Update'
                  color='blue'
                  icon='save'
                  labelPosition='right'
                  style={{ marginRight: '5px' }}
                  onClick={() => setShowConfirmSave(true)}
                /> : 
                <Button
                  type='button'
                  content='Create'
                  color='blue'
                  icon='paper plane outline'
                  labelPosition='right'
                  style={{ marginRight: '5px' }}
                  onClick={() => setShowConfirmSave(true)}
                />
            }
            <Button
              type='button'
              content='Cancel'
              color='red'
              icon='times'
              labelPosition='right'
              style={{ marginRight: '5px' }}
              onClick={() => onClose(false)}
            />
          </div>
        </div>
      </DialogActions>
      <Confirm 
        open={showConfirmDelete}
        content='Are you sure to delete this province.'
        onConfirm={() => props.deleteProvince(
          valueForm.id, 
          () => {
            setShowConfirmDelete(false)
            onClose(false)
          })
        }
        onCancel={() => setShowConfirmDelete(false)}
      />
      <Confirm 
        open={showConfirmSave}
        content={`Are you sure to ${valueForm.id ? 'update' : 'create'} this province.`}
        onConfirm={() => {
          if (valueForm.id) { // UPDATE
            props.updateProvince(valueForm, () => onClose(false))
          } else { // CREATE
            props.createProvince(valueForm, () => onClose(false))
          }
        }}
        onCancel={() => setShowConfirmSave(false)}
      />
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const { data } = props
  const editData = data || {}
  const valueForm = getFormValues('provinceForm')(state) || {}
  
  return ({
    initialValues: {
      id: editData.id,
      nameTh: editData.nameTh,
      nameEn: editData.nameEn,
      code: editData.code
    },
    valueForm: valueForm,
  })
}

const mapDispatchToProps = {
  createProvince, 
  updateProvince
}

const ProvinceModalForm = reduxForm({
  form: 'provinceForm',
  enableReinitialize: true,
})(ProvinceModal)

export default connect(mapStateToProps, mapDispatchToProps)(ProvinceModalForm)